import React, { Component } from 'react'
import PropTypes from 'prop-types'
import StyleSheet from 'styles/StyleSheet'
import Noise from 'img/noise.png'
import Button from '@material-ui/core/Button'
import { Link } from 'react-router-dom'
import { authorizedLink } from 'utils'
import { baseTheme } from 'styles'
import { DealSheetUtils } from 'utils'
import {FormattedMessage} from 'react-intl'

export class FeaturedDealSheetCard extends Component{

  static propTypes = {
    showMoreButton: PropTypes.bool
  }

  static defaultProps = {
    showMoreButton: false,
  }
  /**
   * Start our periodic refresh of the timer component
   */
  componentDidMount = () => {
    this.refreshInterval = global.setInterval(() => {
      this.forceUpdate()
    }, 1000)
  }

  /**
   * End our periodic refresh of the timer component
   */
  componentWillUnmount = () => {
    global.clearInterval(this.refreshInterval)
  }


  get attributes(){
    return this.props.dealSheet
  }

  get currencyCode(){
    return this.attributes.currency && this.attributes.currency.code
  }

  /**
   * Calculate the values and labels for the countdown-timer
   */
  get countdownStatus(){
    return DealSheetUtils.countdownStatus(this.props.dealSheet)
  }

  render = () => {
    let countdownStatus = this.countdownStatus
    return (
      <div className={`${styles('cardContainer')} ` + this.props.className}>
        <div className={styles.cardBody} style={{backgroundImage: (this.props.dealSheet.theme && this.props.dealSheet.theme.backgroundImage)}}>
          <img alt='' className={styles.blurredLogo} src={authorizedLink(this.props.dealSheet.logoUrls.medium)}/>
          <div className={styles.noiseContainer}>
            <div style={{backgroundImage: `url(${Noise})`}} className={styles.noise}></div>
          </div>
          <div className={styles.cardCenteredContainer}>
            <div className={styles.cardInner}>
              <div className={styles.logo}>
                <Link to={`/deal_sheets/${this.props.dealSheet.id}/view`}>
                  {
                    this.props.dealSheet.logoUrls.medium &&
                    <img alt='' className={styles.logo} src={authorizedLink(this.props.dealSheet.logoUrls.medium)}/>
                  }
                </Link>
              </div>
              <div className={styles.descriptionWrap}>
                <div className={styles.description}>
                  {this.attributes.shortDescription}
                </div>
              </div>
              <div className={styles.attributesBox}>
                {this.props.dealSheet.typeOfIssuance !== 'product' && (
                  <div className={styles.attribute}>
                    <span className={styles.attributeName}>
                      {countdownStatus.prefix}
                    </span>
                      <span className={styles.attributeValue}>
                      {countdownStatus.timeRemaining}
                    </span>
                  </div>
                )}
                {this.props.dealSheet.typeOfIssuance !== 'product' && (
                  <div className={styles.attribute}>
                    <span className={styles.attributeName}>
                      Sale Cap
                    </span>
                    <span className={styles.attributeValue}>
                      {(parseFloat(this.attributes.saleCap) || 0).toLocaleString()} {this.currencyCode}
                    </span>
                  </div>
                )}
              </div>
              {
                this.props.showMoreButton &&
                <div className={styles.actionButtons}>
                  <Link to={`/deal_sheets/${this.props.dealSheet.id}/view`} style={{textDecoration: 'none', opacity: 1}}>
                    <Button variant='contained' color="primary">
                      <FormattedMessage id="deal.featured.action" />
                    </Button>
                  </Link>
                </div>
              }
            </div>
          </div>
        </div>
      </div>
    )
  }
}

const styles = StyleSheet({
  noiseContainer: {
    width: 0,
    height: 0,
    padding: 1,
    overflow: 'visible'
  },
  noise: {
    marginTop: -20,
    marginLeft: -40,
    width: 10000,
    height: 10000,
    backgroundRepeat: 'repeat'
  },
  cardContainer: {
    position: 'relative',
    overflow: 'hidden',
    display: 'flex',
    flex: '1 0 auto',
    flexDirection: 'column',
    fontFamily: 'Montserrat,sans-serif',
    '*': {
      fontFamily: 'Montserrat,sans-serif'
    }
  },
  cardCenteredContainer: {
    maxWidth: baseTheme.siteStyleguide.maxWidth,
    width: '100%',
    margin: '0 auto',
    boxSizing: 'border-box',
    padding: '50px 20px 80px 20px',
    '@media(max-width: 600px)': {
      paddingBottom: 40,
      paddingTop: 30,
      paddingLeft: 0
    }
  },
  cardInner: {
    maxWidth: '600px',
    padding: '0 20px'
  },
  cardBody: {
    flex: 1,
    padding: '20px 0px',
    color: '#fff',
    backgroundImage: 'linear-gradient(109deg, #473b7b, #3584a7 51%, #30d2be)',
    position: 'relative',
  },
  logo: {
    fontWeight: 'bold',
    fontSize: 42,
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    marginBottom: 10,
    '& img': {
      maxWidth: '90%',
      maxHeight: '90px',
      height: 'auto'
    },
    '& a' : {
      color: 'inherit',
      textDecoration: 'none',
      display: 'flex',
      alignItems: 'center',
      '&:hover': {
        textDecoration: 'underline',
      }
    }
  },
  blurredLogo: {
    position: 'absolute',
    bottom: 0,
    right: '40%',
    maxHeight: '200px',
    opacity: 0.33,
    filter: 'blur(8px)',
    transform: 'translate(100%, 30%)'
  },
  attributesBox: {
    display: 'flex',
    flexDirection: 'row',
    flex: 1,
    flexWrap: 'wrap',
    alignItems: 'flex-end'
  },
  attribute: {
    display: 'flex',
    flexDirection: 'column',
    flex: '0 1',
    minWidth: 250,
    marginTop: 20,
    '&:not(:last-child)': {
      borderRight: '1px solid white',
      '@media(max-width: 1100px)': {
        borderRight: 'none'
      },
      marginRight: '50px'
    }
  },
  attributeName: {
    color: '#def1ff',
    fontSize: '18px',
    fontWeight: 'bold',
    textShadow: '0 0 10px #ffffff1a, 1px 0px 10px rgba(255, 255, 255, 0.18)',
    marginBottom: 10,
  },
  attributeValue: {
    fontSize: 32,
    fontWeight: 'bold'
  },
  descriptionWrap: {
    marginTop: 10,
    marginBottom: 35,
  },
  description: {
    fontSize: 22,
    lineHeight: 1.5,
    marginRight: -16,
    '@media(max-width: 700px)': {
      fontSize: 16,
      maxHeight: 102,
    }
  },
  actionButtons: {
    marginTop: 25,
    marginBottom: -35,
    '@media(max-width: 700px)': {
      display: 'flex',
      justifyContent: 'center',
      marginBottom: -20,
    },
  }
})

export default FeaturedDealSheetCard